import {
    APP_SET_SHOW_SETTINGS_STATE,
    APP_SET_SHOW_LOGIN_STATE,
    APP_SET_AUTOLAUNCH_ENABLED_STATE,
} from '../constants'

export function actionAppSetShowSettingsState(showSettings) {
    return {
        type: APP_SET_SHOW_SETTINGS_STATE,
        payload: showSettings,
    }
}

export function actionAppSetShowLoginState(showLogin) {
    return {
        type: APP_SET_SHOW_LOGIN_STATE,
        payload: showLogin,
    }
}

export function actionAppSetAutoLaunchEnabledState(enabled) {
    return {
        type: APP_SET_AUTOLAUNCH_ENABLED_STATE,
        payload: enabled,
    }
}



// WEBPACK FOOTER //
// ./src/actions/app.js